import {Component, ElementRef, OnInit, Renderer2, ViewChild, OnDestroy} from '@angular/core';
import {FormGroup, Validators, FormControl} from '@angular/forms';
import {countries} from '../dashboard/account-details/countries';
import * as globals from '../settings';
import {LoginService} from '../shared/navigation/login.service';
import {CookieService} from 'ngx-cookie-service';
import {LotteriesService} from '../lotteries.service';
import {SubscriptionsService} from '../_services/subscriptions.service';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {isArray} from 'rxjs/util/isArray';
import {GetDeviceService} from '../_services/get-device.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {CardService} from '../_services/card.service';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {JsontranslateService} from '../_services/jsontranslate.service';
import {BowserService} from 'ngx-bowser';
import {UserService} from '../_services/user.service';
import {GameLauncherService} from '../_services/game-launcher.service';
import {ActionService} from '../_services/action.service';
import {Location} from '@angular/common';
import {CurrencyService} from '../_services/currency.service';
import {GetPaymentMethodsService} from '../shared/paymentMethod/get-payment-methods.service';
import {BonusService} from '../_services/bonus.service';

@Component({
    selector: 'app-fresh-registration',
    templateUrl: './fresh-registration.component.html',
    styleUrls: ['./fresh-registration.component.scss', './flags.css'],
    providers: [CardService]
})
export class FreshRegistrationComponent implements OnInit, OnDestroy {
    @ViewChild('paymentMethods') paymentMethods: ElementRef;
    @ViewChild('paymentGrid') paymentGrid: ElementRef;
    letsGo: boolean;
    showSemiTooltip: boolean;
    step: number;
    prefixCountries: any;
    isMobile: boolean;
    selectedCode: any;
    selectedPrefix: any;
    selected: any;
    passwordIsVisible: boolean;
    passwordFieldType: string;
    birthDateIsValid: boolean;
    buttonType: string;
    goTo: string;
    emailIsAvalible: boolean;
    emailIAarr: any;
    lastType: number;
    tooltipMessage: string;
    cartItems: number;
    languageChange: any;
    languagePage: string;
    currentMethod: string;
    getAvailablePaymentOptions: any;
    gapo: any;
    currentPM: string;
    currentPMname: string;
    realNamePM: string;
    currentPMchecked: string;
    device: any;
    confStat: string;
    currentError: string;
    cardType: string;
    os: string;
    browser: string;
    showOnlyPM: boolean;
    step_1_validated: boolean;
    step_2_validated: boolean;
    step_3_validated: boolean;
    step_1_checked: boolean;
    step_2_checked: boolean;
    step_3_checked: boolean;
    activeTooltip: boolean;
    tooltipLoop: number;
    showBirthDate: boolean;
    isLoadingButton: boolean;
    registerContainerScrollTop: number;
    registerForm: FormGroup;
    firstName: FormControl;
    lastName: FormControl;
    email: FormControl;
    password: FormControl;
    mobile: FormControl;
    prefix: FormControl;
    address: FormControl;
    city: FormControl;
    postcode: FormControl;
    terms: FormControl;
    gender: FormControl;
    birthDay: FormControl;
    birthMonth: FormControl;
    birthYear: FormControl;
    expiryDate: FormControl;
    securityCode: FormControl;
    nameOnCard: FormControl;
    cardNumber: FormControl;
    currency: FormControl;
    NettelerSecureId: FormControl;
    NettelerAccount: FormControl;
    Payee: FormControl;
    IBAN: FormControl;
    Swift: FormControl;
    EnterCashEmail: FormControl;
    MoneyBookersId: FormControl;
    countryCode: FormControl;
    country: FormControl;
    registerSubscription: Subscription;
    onlyPmStep: Subscription;
    subscription: Subscription;
    holdHorsesTimestamp: number;
    waitingForResponse: boolean;
    fakeCart: boolean; /* we use that for games */
    checkIfInCartOpenSubscription: Subscription;
    checkIfGameRunSubscription: Subscription;
    changedCurrency: Subscription;
    checkIfInCart: boolean;
    checkIfGameRun: boolean;
    countryForPayments: any;
    userDetails: any;
    userDataNameWithGender: any;
    close: boolean;
    currentYear: number;
    lastYear: number;
    androidDayValue: number;
    androidOldDayValue: number;
    androidMonthValue: number;
    androidOldMonthValue: number;
    androidYearValue: number;
    androidOldYearValue: number;
    tmpCurrency: string;
    preselectedCurrency: any;
    allCurrencies: any;
    defaultCurrency: any;
    ifDwSelectIsOpen: boolean[];
    dayValuesForDw: any;
    monthValuesForDw: any;
    yearValuesForDw: any;
    varInvalid: boolean[];
    brand = globals.brand;
    frontDomain = globals.frontDomain;
    fromValidator: boolean;
    IOS_native: boolean;
    defaultYear: any;
    paystackFlow: boolean;
    holdButtonDisabled: boolean;
    emailValueFromInput: any;
    hold: boolean;
    globalListenFunc: Function;
    onlyOnce: boolean;
    currentGameId: string;
    subsCurrentGameId: Subscription;
    loggedStatus: Subscription;
    bonusDetails: any;
    showConfirmation: boolean;

    constructor(private loginService: LoginService,
                private cookieService: CookieService,
                public subscriptionsService: SubscriptionsService,
                private renderer: Renderer2,
                public lotteryService: LotteriesService,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private getDeviceService: GetDeviceService,
                private deviceService: DeviceDetectorService,
                private cardService: CardService,
                private translate: TranslateService,
                private jsontranslate: JsontranslateService,
                private bowserService: BowserService,
                private userService: UserService,
                public actionService: ActionService,
                private gameLauncher: GameLauncherService,
                public currencyService: CurrencyService,
                public getpmService: GetPaymentMethodsService,
                public bonusService: BonusService
    ) {
        this.holdButtonDisabled = false;
        this.paystackFlow = false;
        this.ifDwSelectIsOpen = [];
        this.freshStart();
        this.languagePage = this.translate.currentLang;
        this.jsontranslate.loadTranslations('FreshRegistrationComponent', this.translate.currentLang);
        this.subscription = this.subscriptionsService.getCartItems().subscribe(cartLength => {
            this.cartItems = cartLength;
        });
        this.fakeCart = false;
        this.subscriptionsService.getFakeCart().subscribe(fc => {
            this.fakeCart = fc;
        });
        this.subsCurrentGameId = this.subscriptionsService.getCurrentGameId().subscribe(gameId => {
            this.currentGameId = gameId;
        });

        this.registerSubscription = this.subscriptionsService.getRegister().subscribe(register => {
            this.openReg(register).then((resolve) => {
                if (resolve === 'registration') {
                    this.showOnlyAddPm();
                }
            });
            if (!register) {
                this.freshStart();
            }
        });

        this.showOnlyPM = false;
        this.onlyPmStep = this.subscriptionsService.getOnlyPmStep().subscribe(onlyPmStep => {
            this.showOnlyPM = onlyPmStep;
            if (onlyPmStep) {
                setTimeout(() => {
                    this.freshStart();
                }, 50);
                setTimeout(() => {
                    this.step_1_validated = true;
                    this.step_2_validated = true;
                    this.showOnlyPM = true;
                    this.buttonType = 'submit';
                }, 51);
            }
        });
        this.device = this.deviceService.getDeviceInfo();
        this.os = this.device.os !== 'unknown' ? this.device.os : this.getDeviceService.getOS();
        if (this.bowserService.bowser.name && this.bowserService.bowser.version) {
            this.browser = JSON.stringify(this.bowserService.bowser.name).replace(/"/g, '') + '-' +
                JSON.stringify(this.bowserService.bowser.version).replace(/"/g, '');
        }

        this.checkIfInCartOpenSubscription = this.subscriptionsService.getIfInCart().subscribe(checkIfInCart => {
            this.checkIfInCart = checkIfInCart;
        });

        this.checkIfGameRunSubscription = this.subscriptionsService.getIfGameRun().subscribe(checkIfGameRun => {
            this.checkIfGameRun = checkIfGameRun;
        });

        this.loggedStatus = this.subscriptionsService.getLoggedInStatus().subscribe(data => {
            if (!this.getAvailablePaymentOptions) {
                this.getAvaliblePaymentMethods();
            }
        });

        const current = new Date();
        this.currentYear = current.getFullYear();
        this.lastYear = this.currentYear - 18;

        this.preselectedCurrency = this.currencyService.currency;
        this.changedCurrency = this.subscriptionsService.getChangeCurrency().subscribe(currency => {
            if (currency) {
                this.preselectedCurrency = currency;
            }
        });
        this.preselectCurrency();
        this.varInvalid = [];

        this.dayValuesForDw = this.getValueForDw(31);
        this.monthValuesForDw = this.getValueForDw(12);
        this.yearValuesForDw = this.getYearForDw();
        this.fromValidator = false;
        if (navigator.userAgent.includes('app=IOS_APP')) {
            this.IOS_native = true;
        }
        this.defaultYear = {selectDisplayName: (this.currentYear - 18) + '', selectValue: (this.currentYear - 18) + ''};
        this.lotteryService.windowSizeCheck();
        this.isMobile = this.lotteryService.isMobile;
    }

    browserNavigate(event, url) {
        this.router.navigate(['/' + this.languagePage, url]).then(resolver => {
            this.closeRegistration();
        });
    }

    openReg(open) {
        return new Promise(resolve => {
            if (open === true) {
                this.step = 1;
                this.close = true;
                this.letsGo = true;
                this.rebuildForm();
                resolve('registration');
            } else {
                this.letsGo = false;
            }
            this.autoPickCountry();
        });
    }

    ngOnDestroy() {
        if (this.registerSubscription) {
            this.registerSubscription.unsubscribe();
        }
        if (this.onlyPmStep) {
            this.onlyPmStep.unsubscribe();
        }
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this.changedCurrency) {
            this.changedCurrency.unsubscribe();
        }
        if (this.globalListenFunc) {
            this.globalListenFunc();
        }
        if (this.subsCurrentGameId) {
            this.subsCurrentGameId.unsubscribe();
        }
        if (this.loggedStatus) {
            this.loggedStatus.unsubscribe();
        }
    }

    preselectCurrency() {
        this.preselectedCurrency = 'EUR';
        const lsCurrency = localStorage.getItem('currency');
        if (lsCurrency) {
            this.preselectedCurrency = lsCurrency;
        }
    }

    freshStart() {
        if (!this.showOnlyPM) {
            this.step = 1;
        }
        this.confStat = 'start';
        this.letsGo = false;
        this.passwordIsVisible = false;
        this.passwordFieldType = 'password';
        this.buttonType = 'button';
        this.step_1_validated = false;
        this.step_1_checked = false;
        this.step_2_validated = false;
        this.step_2_checked = false;
        this.step_3_validated = false;
        this.step_3_checked = false;
        this.birthDateIsValid = true;
        this.emailIsAvalible = false;
        this.emailIAarr = [];
        this.currentPM = 'Card';
        this.goTo = 'startFlow';
        this.tooltipMessage = '';
        this.tooltipLoop = 0;
        this.hideTooltip('canDisableTooltip');
        this.isLoadingButton = false;
        this.holdHorsesTimestamp = 0;
        this.waitingForResponse = false;
        this.checkIfInCart = false;
        this.checkIfGameRun = false;
        this.subscriptionsService.emitJinniError(0);
    }

    resetBirthDate() {
        this.showBirthDate = false;
        setTimeout(() => {
            this.showBirthDate = true;
        }, 1);
    }

    rebuildForm() {
        if (this.registerForm) {
            this.resetBirthDate();
            const holdPrefix = this.prefix.value;
            this.registerForm.reset();
            this.registerForm.controls['prefix'].setValue(holdPrefix);
            this.registerForm.controls['prefix'].updateValueAndValidity();
        }
    }

    showOnlyAddPm() {
        if (this.showOnlyPM && this.brand === 'qiwi') {
            this.step = 3;
            this.letsGo = false;
            this.buttonType = 'submit';
            this.step_1_validated = true;
            this.step_2_validated = true;
            this.getAvaliblePaymentMethods();
            const userData = JSON.parse(localStorage.getItem('playerDetails'));
            if (/[A-Za-z]+/.test(userData.FirstName) && /[A-Za-z]+/.test(userData.LastName)) {
                this.registerForm.controls['nameOnCard'].setValue(userData.FirstName + ' ' + userData.LastName);
            }
            this.getBonusDetails();
            // } else if (this.showOnlyPM && this.brand === 'winaija') {
            // this.closeRegistration();
            // this.subscriptionsService.emitUserNeedIncreseBalance(-1);
        }
    }

    preventTrigger(event) {
        if (event.keyCode === 13) {
            event.preventDefault();
        }
    }

    ngOnInit() {
        this.handlePrefixCountries();
        this.createFormControls();
        this.createForm();
        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.languagePage = this.translate.currentLang;
            this.jsontranslate.loadTranslations('FreshRegistrationComponent', this.translate.currentLang);
        });
    }

    autoPickCountry() {
        const country = localStorage.getItem('country');
        this.prefixCountries.forEach((item) => {
            if (item && item.code === country) {
                this.checkForCode(item, item);
            }
        });
    }

    onScroll(event) {
        event.target.scrollTop = 0;
    }

    closeRegistration() {
        this.subscriptionsService.updateTriggeredEndGameSessionIG(false);
        this.close = true;
        this.letsGo = false;
        setTimeout(() => {
            this.renderer.removeClass(document.body, 'modal-open-register');
            this.subscriptionsService.emitRegister(false);
            const emitFreshRegisteredInCasino = localStorage.getItem('emitFreshRegisteredInCasino');
            if (!emitFreshRegisteredInCasino) {
                this.subscriptionsService.closeModalNow(true);
            }
            this.subscriptionsService.emitToggleContent(true);
            this.subscriptionsService.emitFakeCart(false);
            if (localStorage.getItem('waitingForDone') === 'minicheckout') {
                this.subscriptionsService.updateMiniCheckoutAddPM(false);
                localStorage.removeItem('waitingForDone');
            }
            this.activatedRoute.queryParams.subscribe(params => {
                if (params['action'] === 'deposit') {
                    this.actionService.goToAction(params, this.languagePage, true);
                    const url: string = this.router.url.substring(0, this.router.url.indexOf('?'));
                    this.router.navigateByUrl(url);
                }
            });
            if (this.actionService.redirectAfter) {
                setTimeout(() => {
                    this.router.navigateByUrl(this.actionService.redirectAfter);
                }, 1500);
            }
            setTimeout(() => {
                this.subscriptionsService.onlyPmStep(false);
            }, 500);
        }, 100);
        setTimeout(() => {
            this.freshStart();
        }, 1500);

        if (!this.checkIfInCart && !this.router.url.includes('/casino') && !this.subscriptionsService.miniCheckoutEnabled) {
            setTimeout(() => {
                this.subscriptionsService.setIsAddFundsOpen(true);
            }, 500);
        }
        setTimeout(() => {
            this.resetBonusDetails();
        }, 300);
    }


    goBack() {
        if (this.step === 2) {
            this.step = 1;
            this.buttonType = 'button';
        }
    }

    handlePrefixCountries() {
        this.lotteryService.getLotteries(globals.appDomain + '/config/getAllowedCountries/countries.json').subscribe(data => {
            const countryArray = [];
            if (this.brand === 'winaija') {
                data.message = data.message.filter(prefix => prefix.code === 'NG');
                this.selected = data.message[0];
            }
            data.message.forEach(el => {
                el.countryCodeDisplayName = el.dial_code;
                el.selectImageClass = el.code.toLowerCase();
                el.selectValue = el.dial_code;
                el.selectDisplayName = `<span class="countryName">${el.name}</span> <span class="countryCode">${el.dial_code}</span>`;
                if (el.code !== 'US') { /* hardcoded as hotfix, tasks #2311 and #3290 */
                    countryArray.push(el);
                }
            });
            this.sortPrefixCountries(countryArray);
        });
    }

    onSelectMethod(value) {
        this.checkForCode(value, value);
    }

    sortPrefixCountries(country) {
        const prefixes = [];
        country.forEach((el) => {
            el.codeAsNumber = +el.dial_code.replace('+', '');
            prefixes.push(el);
        });
        this.prefixCountries = prefixes;
        this.autoPickCountry();
        return this.prefixCountries;
    }

    getValueForDw(n) {
        const day = [];
        for (let d = 1; d <= n; d++) {
            day.push({'selectDisplayName': d + '', 'selectValue': d + ''});
        }
        return day;
    }

    getYearForDw() {
        const year = [];
        const currentYear = (new Date()).getFullYear() - 18;
        for (let y = currentYear; y >= (currentYear - 100); y--) {
            year.push({'selectDisplayName': y + '', 'selectValue': y + ''});
        }
        return year;
    }

    showHidePwd() {
        this.passwordIsVisible = !this.passwordIsVisible;
        if (this.passwordIsVisible) {
            this.passwordFieldType = 'text';
        } else {
            this.passwordFieldType = 'password';
        }
    }

    createFormControls() {
        this.firstName = new FormControl('', Validators.compose([Validators.required,
            Validators.minLength(2),
            Validators.maxLength(24),
            Validators.pattern(/^[^~`!@#$%^&*()|0-9_+=[\]{}:;"<>,?\/\\]*$/i)]));
        this.lastName = new FormControl('', Validators.compose([Validators.required,
            Validators.minLength(2),
            Validators.maxLength(24),
            Validators.pattern(/^[^~`!@#$%^&*()|0-9_+=[\]{}:;"<>,?\/\\]*$/i)]));
        this.email = new FormControl('', [
            Validators.required,
            Validators.minLength(5),
            Validators.maxLength(80),
            Validators.pattern('^[a-zA-Z0-9!#$%&\\\'*+\\\\=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&\\\'*+\\\\=' +
                '?^_`{|}~-]+)*@(?:[a-' +
                'zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$')
        ]);
        this.password = new FormControl('', [
            Validators.required,
            Validators.minLength(8)
        ]);
        this.mobile = new FormControl('', [
            Validators.required,
            Validators.minLength(4),
            Validators.maxLength(12),
            Validators.pattern('[0-9]+')
        ]);
        this.prefix = new FormControl('', Validators.required);
        this.address = new FormControl('', Validators.compose([Validators.required,
            Validators.minLength(2),
            Validators.maxLength(90)]));
        this.city = new FormControl('', Validators.compose([Validators.required,
            Validators.minLength(2),
            Validators.maxLength(24)]));
        this.postcode = new FormControl('', Validators.compose([Validators.required,
            Validators.minLength(2),
            Validators.maxLength(10)]));
        this.terms = new FormControl('', Validators.required);
        this.gender = new FormControl('', Validators.required);
        this.birthDay = new FormControl('', Validators.required);
        this.birthMonth = new FormControl('', Validators.required);
        this.birthYear = new FormControl('', Validators.required);
        this.expiryDate = new FormControl('', Validators.compose([Validators.required,
            Validators.pattern('([0-9]{1,})[/][0-9]{2}')]));
        this.securityCode = new FormControl('', Validators.compose([Validators.required,
            Validators.pattern('([0-9]{3,})'),
            Validators.minLength(3),
            Validators.maxLength(4)]));
        this.nameOnCard = new FormControl('', Validators.compose([Validators.required,
            Validators.minLength(3), Validators.pattern(/[A-Za-z]+/)]));
        this.cardNumber = new FormControl('', Validators.compose([Validators.required,
            Validators.minLength(14),
            Validators.maxLength(23)]));
        this.NettelerSecureId = new FormControl('', Validators.required);
        this.NettelerAccount = new FormControl('', Validators.required);
        this.Payee = new FormControl('', [Validators.required,
            Validators.minLength(3),
            Validators.maxLength(255)]);
        this.IBAN = new FormControl('', [Validators.required,
            Validators.minLength(1),
            Validators.maxLength(255)]);
        this.Swift = new FormControl('', [Validators.required,
            Validators.minLength(1),
            Validators.maxLength(255)]);
        this.EnterCashEmail = new FormControl('', [
            Validators.required, Validators.pattern('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))' +
                '@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$')
        ]);
        this.MoneyBookersId = new FormControl('', [
            Validators.required, Validators.pattern('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))' +
                '@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$')
        ]);
        this.countryCode = new FormControl('', Validators.required);
        this.country = new FormControl('', Validators.required);
        this.currency = new FormControl('', Validators.required);
    }

    createForm() {
        this.registerForm = new FormGroup({
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            password: this.password,
            mobile: this.mobile,
            prefix: this.prefix,
            address: this.address,
            city: this.city,
            postcode: this.postcode,
            terms: this.terms,
            gender: this.gender,
            birthDay: this.birthDay,
            birthMonth: this.birthMonth,
            birthYear: this.birthYear,
            expiryDate: this.expiryDate,
            securityCode: this.securityCode,
            nameOnCard: this.nameOnCard,
            cardNumber: this.cardNumber,
            NettelerSecureId: this.NettelerSecureId,
            NettelerAccount: this.NettelerAccount,
            Payee: this.Payee,
            Swift: this.Swift,
            IBAN: this.IBAN,
            EnterCashEmail: this.EnterCashEmail,
            MoneyBookersId: this.MoneyBookersId,
            countryCode: this.countryCode,
            country: this.country,
            currency: this.currency
        });
    }

    toSendNoEmail(value) {
        let val = JSON.stringify(value);
        val = val
            .replace(/,/g, '&')
            .replace(/{/g, '')
            .replace(/}/g, '')
            .replace(/"/g, '')
            .replace(/:/g, '=');
        return val;
    }

    registerUser() {
        const urlParam = {};
        let urlParams = '';
        const cookieMcExists: boolean = this.cookieService.check('mc');
        const cookieJlpidExists: boolean = this.cookieService.check('jlpid');
        const cookieCampaignExists: boolean = this.cookieService.check('campaign');
        const cookieReferralExists: boolean = this.cookieService.check('referral');
        const cookieIncentiveCodeExists: boolean = this.cookieService.check('incentiveCode');
        const cookieBtagExists: boolean = this.cookieService.check('btag');
        if (cookieMcExists || cookieJlpidExists || cookieCampaignExists ||
            cookieReferralExists || cookieIncentiveCodeExists || cookieBtagExists) {
            if (cookieMcExists) {
                const mc = this.cookieService.get('mc');
                urlParam['mc'] = mc;
            }
            if (cookieJlpidExists) {
                const jlpid = this.cookieService.get('jlpid');
                urlParam['jlpid'] = jlpid;
            }
            if (cookieCampaignExists) {
                const campaign = this.cookieService.get('campaign');
                urlParam['campaign'] = campaign;
            }
            if (cookieReferralExists) {
                const referral = this.cookieService.get('referral');
                urlParam['referral'] = encodeURIComponent(referral);
            } else {
                urlParam['referral'] = encodeURIComponent(window.location.href);
            }
            if (cookieIncentiveCodeExists) {
                const incentiveCode = this.cookieService.get('incentiveCode');
                urlParam['cookieValue'] = incentiveCode;
            }
            if (cookieBtagExists) {
                const btag = this.cookieService.get('btag');
                urlParam['bTag'] = btag;
                urlParam['affiliateId '] = btag.split('_')[0];
            }

            urlParams = '?' + this.lotteryService.toSendNoEmail(urlParam);
        }

        if (this.step_1_validated && this.step_2_validated && this.step === 2) {
            const val = Object();
            val.email = this.email.value;
            val.password = this.password.value;
            val.gender = this.gender.value;
            val.firstName = this.firstName.value;
            val.lastName = this.lastName.value;
            val.phone_prefix = parseInt(this.prefix.value.replace(/\s/g, ''), 10);
            val.phone_number = this.mobile.value;
            val.city = this.city.value;
            val.address = this.address.value;
            val.postCode = this.postcode.value;
            val.birth_day = this.birthDay.value;
            val.birth_month = this.birthMonth.value;
            val.birth_year = this.birthYear.value;
            val.termsAndConditions = this.terms.value;
            val.birthDate = val.birth_year + '-' + val.birth_month + '-' + val.birth_day;
            val.phoneNumber = '%2B' + val.phone_prefix + '-' + val.phone_number;
            val.countryCode = this.countryCode.value;
            val.country = this.country.value;
            if (typeof this.currency.value === 'string') {
                val.currency = this.currency.value;
            } else {
                val.currency = this.currency.value.selectValue;
            }
            if (this.country.value === null || this.countryCode.value === null) {
                this.prefixCountries.forEach((item, index) => {
                    if (item.dial_code === this.prefix.value) {
                        val.countryCode = item.code;
                        val.country = item.name;
                    }
                });
            }
            val.lang = localStorage.getItem('pageLanguage');

            this.device = this.deviceService.getDeviceInfo();
            val.device = this.device.device !== 'unknown' &&
            this.device.device !== 'Unknown' ? this.device.device : this.getDeviceService.getDevice();
            val.device += ' ';
            val.device += this.device.os_version !== 'unknown' &&
            this.device.os_version !== 'Unknown' ? this.device.os_version : this.getDeviceService.getOSVersion();
            val.os = this.device.os !== 'unknown' && this.device.os !== 'Unknown' ? this.device.os : this.getDeviceService.getOS();
            if (this.bowserService.bowser.name && this.bowserService.bowser.version) {
                val.browser = JSON.stringify(this.bowserService.bowser.name).replace(/"/g, '') +
                    '-' + JSON.stringify(this.bowserService.bowser.version).replace(/"/g, '');
            }
            this.languageChange = this.subscriptionsService.getLanguage().subscribe(lang => {
                this.languagePage = lang;
            });

            if (window.location.href.indexOf('/casino') > -1 && window.location.href.indexOf('mc=') === -1) {
                val.mc = 'casino';
                val.mc = 'casino';
            }

            this.loginService.logIn(globals.appDomain + '/user/register/userRegister.json' + urlParams + '&XDEBUG_SESSION_START=10137', this.toSendNoEmail(val))
                .subscribe(
                    response => {
                        if (response && response.message && response.message.SessionID) {
                            const loggedInUser = response.message;
                            loggedInUser.sessionId = response.message.SessionID;
                            loggedInUser.memberId = response.message.MemberID;
                            localStorage.setItem('playerDetails', JSON.stringify(loggedInUser));
                            sessionStorage.setItem('registed', 'true');
                            const userData = response.message;
                            localStorage.setItem('playerDetails', JSON.stringify(userData));
                            this.subscriptionsService.emitFireRegisterPixel(true);
                            if (!this.fakeCart) {
                                this.subscriptionsService.emitUserAfterRegistration(userData);
                                this.subscriptionsService.emitNewUser(true);
                            } else {
                                this.userDataNameWithGender = {
                                    FirstName: userData.FirstName,
                                    LastName: userData.LastName,
                                    Gender: userData.Gender,
                                };
                                this.subscriptionsService.updateUserDataNameWithGender(this.userDataNameWithGender);
                                this.subscriptionsService.updateBalance(userData.TotalBalance);
                            }
                            if (this.cartItems === 0 && !this.fakeCart) {
                                this.closeRegistration();
                                this.activatedRoute.queryParams.subscribe(params => {
                                    this.actionService.goToAction(params, this.languagePage, true);
                                });
                            } else if (this.brand === 'qiwi') {
                                this.userService.step3 = true;
                                this.step = 3;
                                this.confStat = 'start';
                                this.isLoadingButton = false;
                                this.registerContainerScrollTop = 0;
                            } else if (this.brand === 'winaija') {
                                this.closeRegistration();
                            }
                            localStorage.setItem('knownUser', 'true');
                            this.subscriptionsService.emitChangeCurrency(response.message.Currency);
                            this.userService.getUser();
                            this.getAvaliblePaymentMethods();
                            setTimeout(() => {
                                this.getpmService.getPaymentMethods();
                            }, 100);
                            if (window.location.href.indexOf('/casino') > -1) {
                                this.subscriptionsService.isFreshRegisteredForFDB = true;
                                localStorage.setItem('emitFreshRegisteredInCasino', 'true');
                            }
                            this.getBonusDetails();
                        } else {
                            this.confStat = 'error';
                            this.buttonType = 'button';
                            this.goTo = 'tryAgain';
                            this.isLoadingButton = false;
                            if (response.message.ErrorID !== undefined) {
                                this.subscriptionsService.emitJinniError(response.message.ErrorID);
                                if (this.email.invalid || this.mobile.invalid || this.password.invalid) {
                                    this.step = 1;
                                    this.step_1_validated = false;
                                    this.buttonType = 'button';
                                    this.goTo = 'startFlow';
                                    this.confStat = 'start';
                                }
                            }
                        }
                    });
        } else if (this.step_1_validated && this.step_2_validated && this.step_3_validated && this.step === 3) {
            let urlToSend = 'paymentOptionType=' + this.currentPM;
            if (this.currentPM === 'Card') {
                const ed = this.expiryDate.value.split('/');
                urlToSend += '&paymentOptionId[ccExpMonth]=' + ed[0];
                urlToSend += '&paymentOptionId[ccExpYear]=' + ed[1];
                urlToSend += '&paymentOptionId[ccCardNumber]=' + this.cardNumber.value.replace(/\s/g, '');
                urlToSend += '&paymentOptionId[ccNameOnCard]=' + this.nameOnCard.value;
                urlToSend += '&paymentOptionId[CVV]=' + this.securityCode.value;
                this.realNamePM = 'Card';
            }
            if (this.currentPM === 'apmgw_Neteller') {
                urlToSend += '&paymentOptionId[NettelerSecureId]=' + this.NettelerSecureId.value;
                urlToSend += '&paymentOptionId[NettelerAccount]=' + this.NettelerAccount.value;
                this.realNamePM = 'Neteller';
            }
            if (this.currentPM === 'apmgw_Fast_Bank_Transfer') {
                urlToSend += '&paymentOptionId[Payee]=' + this.Payee.value;
                urlToSend += '&paymentOptionId[IBAN]=' + this.IBAN.value;
                urlToSend += '&paymentOptionId[Swift]=' + this.Swift.value;
                this.realNamePM = 'Worldpay';
            }
            if (this.currentPM === 'apmgw_EnterCash') {
                urlToSend += '&paymentOptionId[payer_email]=' + this.EnterCashEmail.value;
                this.realNamePM = 'EnterCash';
            }

            if (this.currentPM === 'apmgw_Sofort') {
                this.realNamePM = 'Sofort';
            }

            if (this.currentPM === 'apmgw_MoneyBookers') {
                urlToSend += '&paymentOptionId[AccountId]=' + this.MoneyBookersId.value + '&apmCallbackSuccessUrl=' + globals.frontDomain;
                this.realNamePM = 'Skrill';
            }

            if (this.currentPM === 'apmgw_Interac') {
                this.realNamePM = 'Interac® Online ';
            }
            if (this.currentPM === 'apmgw_Interac_eTransfer') {
                this.realNamePM = 'Interac® e-Transfer';
            }
            if (this.currentPM === 'apmgw_ecoPayz') {
                this.realNamePM = 'ecoPayz';
            }

            const user = JSON.parse(localStorage.getItem('playerDetails'));
            /* @todo: it' should be changed from localStorage to Daniel's way */

            urlToSend += '&frontend=yes';
            if (user.sessionId) {
                urlToSend += `&sessionId=${user.sessionId}`;
            }
            this.confStat = 'waiting';
            this.buttonType = 'button';
            this.waitingForResponse = true;
            this.lotteryService.postData(
                `${globals.appDomain}/payments/addPaymentMethod/${user.memberId}/paymentsAddPaymentMethod.json`, urlToSend
            ).subscribe(
                result => {
                    if (result.message.ErrorID === undefined) {
                        const userData = JSON.parse(localStorage.getItem('playerDetails'));
                        const langFromLocal = localStorage.getItem('pageLanguage');
                        setTimeout(() => {
                            this.confStat = 'success';
                        }, 1000); /* 1s because #3380 */
                        this.buttonType = 'button';
                        this.goTo = 'close';
                        if (this.router.url.includes('/casino') && this.fakeCart && !this.subscriptionsService.holdCasinoModalVisible) {
                            this.userService.step3 = false;
                            this.closeRegistration();
                        }
                        localStorage.setItem('freshAddedPaymentMethodId', result.message.PaymentOptionId);
                        if (this.fakeCart) {
                            this.subscriptionsService.emitUserAfterRegistration(userData);
                            const emitFreshRegisteredInCasino = localStorage.getItem('emitFreshRegisteredInCasino');
                            if (!this.gameLauncher.gameId && !emitFreshRegisteredInCasino) {
                                this.subscriptionsService.closeModalNow(true);
                                this.activatedRoute.queryParams.subscribe(params => {
                                    this.actionService.goToAction(params, this.languagePage, true);
                                });
                                this.freshStart();
                            }
                        }
                        if (this.gameLauncher.gameId && this.userService.userData.Balance !== '0.00') {
                            this.letsGo = false;
                            setTimeout(() => {
                                this.userService.step3 = false;
                                this.renderer.removeClass(document.body, 'modal-open-register');
                                this.subscriptionsService.emitRegister(false);
                            }, 0);
                        } else if (!this.router.url.includes('/casino') &&
                            this.gameLauncher.gameId && this.userService.userData.Balance === '0.00') {
                            if (this.router.url.includes('/game')) {
                                this.userService.step3 = false;
                                this.closeRegistration();
                            }
                            this.subscriptionsService.emitUserNeedMoreMoney(this.gameLauncher.gameId);
                            this.letsGo = false;
                        }
                        if (this.fakeCart && this.userService.userData.Balance === '0.00') {
                            this.gameLauncher.gameId = this.currentGameId;
                            this.subscriptionsService.emitFakeCart(false);
                            if (!this.router.url.includes('/casino') || (!this.step_1_checked && !this.step_2_checked)) {
                                setTimeout(() => {
                                    this.subscriptionsService.emitUserNeedMoreMoney(this.currentGameId);
                                }, 1000);
                            }
                            this.userService.step3 = false;
                            this.closeRegistration();
                        } else if (this.fakeCart && this.userService.userData.Balance !== '0.00') {
                            this.userService.step3 = false;
                            this.subscriptionsService.emitUserNeedMoreMoney(this.currentGameId);
                        }
                        if (!this.showOnlyPM) {
                            this.subscriptionsService.emitNewUser(true);
                        }
                    } else {
                        if (result.message.ErrorID === '097') {
                            // to display raw error from platform
                            this.currentError = result.message.ErrorParams;
                        } else {
                            const errorId = 'errors.' + result.message.ErrorID;
                            this.translate.get(errorId).subscribe(t => {
                                if (t !== errorId) {
                                    this.currentError = t;
                                } else {
                                    this.translate.get('errors.Default').subscribe(x => {
                                        this.currentError = x;
                                    });
                                }
                            });
                        }
                        this.confStat = 'error';
                        this.buttonType = 'button';
                    }
                    setTimeout(() => {
                        this.waitingForResponse = false;
                        this.getpmService.getPaymentMethods();
                    }, 1500);
                },
                error2 => {
                    this.confStat = 'error';
                    this.buttonType = 'button';
                }
            );
        }
    }

    validateForOnlyAddPm() {
        if (this.showOnlyPM) {
            this.fromValidator = true;
            this.nextStep();
        }
    }

    nextStep() {
        const cookieIncentiveCodeExists: boolean = this.cookieService.check('incentiveCode');
        if (!this.waitingForResponse) {
            if (this.goTo === 'close') {
                this.userService.step3 = false;
                this.closeRegistration();
                if (!this.router.url.includes('/casino')) {
                    if (!this.checkIfInCart && !this.router.url.includes('/cart') && !cookieIncentiveCodeExists) {
                        if (localStorage.getItem('waitingForDone') !== 'minicheckout') {
                            setTimeout(() => {
                                if (!this.checkIfGameRun) {
                                    if (!this.router.url.includes('/scratchcards')) {
                                        this.subscriptionsService.emitUserNeedIncreseBalance(-1);
                                    } else {
                                        this.subscriptionsService.updateRunScratchcardCheckout(this.subscriptionsService.updateRunScratchcardCheckoutObject);
                                    }
                                }
                                this.subscriptionsService.emitForceStepTwo(true);
                            }, 500);
                        }
                    }
                } else if (!this.showOnlyPM) {
                    setTimeout(() => {
                        localStorage.setItem('emitFreshRegisteredInCasino', 'true');
                        this.subscriptionsService.openCasinoWelcomeNow(true);
                    }, 1000);
                }
                setTimeout(() => {
                    this.freshStart();
                }, 1000);

                if (this.router.url.includes('/casino')) {
                    this.subscriptionsService.emitShowAddFundsModal(true);
                }
                this.subscriptionsService.emitNewUser(true);
            } else if (this.step === 1) {
                this.step_1_checked = true;
                if (this.email.valid &&
                    this.emailIsAvalible &&
                    this.mobile.valid &&
                    this.password.valid &&
                    this.prefix.valid) {
                    this.step = 2;
                    this.getAllCurrencies();
                    this.step_1_validated = true;
                    this.buttonType = 'submit';
                    if (this.cartItems === 0 && !this.fakeCart) {
                        this.step_3_validated = true;
                        this.buttonType = 'submit';
                    }
                } else {
                    this.step_1_validated = false;
                }
            } else if (this.step === 2) {
                this.isLoadingButton = true;
                this.step_2_checked = true;
                if (this.step_1_validated === true &&
                    this.email.valid &&
                    this.emailIsAvalible &&
                    this.mobile.valid &&
                    this.password.valid &&
                    this.prefix.valid && this.terms.value &&
                    this.postcode.valid &&
                    this.city.valid &&
                    this.address.valid &&
                    this.lastName.valid &&
                    this.firstName.valid &&
                    this.gender.valid &&
                    this.birthDay.valid &&
                    this.birthMonth.valid &&
                    this.birthYear.valid &&
                    this.birthDateIsValid) {
                    if (/[A-Za-z]+/.test(this.firstName.value) && /[A-Za-z]+/.test(this.lastName.value)) {
                        this.registerForm.controls['nameOnCard'].setValue(this.firstName.value + ' ' + this.lastName.value);
                        this.registerForm.controls['nameOnCard'].updateValueAndValidity();
                    }
                    this.buttonType = 'submit';
                    this.step_2_validated = true;
                } else {
                    if (!this.terms.value) {
                        this.varInvalid['Terms'] = true;
                    }
                    if (!this.email.valid ||
                        !this.emailIsAvalible ||
                        !this.mobile.valid ||
                        !this.password.valid ||
                        !this.prefix.valid) {
                        this.step = 1;
                        this.step_1_validated = false;
                    }
                    this.step_2_validated = false;
                    this.isLoadingButton = false;
                }
            } else if (this.step === 3 && this.confStat === 'error') {
                this.waitingForResponse = true;
                this.confStat = 'start';
                this.buttonType = 'submit';
                this.waitingForResponse = false;
            } else if (this.step === 3 && this.confStat !== 'error') {
                this.step_3_checked = true;
                this.currentPMchecked = this.currentPM;
                if (!this.fromValidator) {
                    this.getpmService.getPaymentMethods();
                }
                this.fromValidator = false;
                this.validatePmsForOnly3Step();
            }
        }
    }

    checkForCode(event, value) {
        this.prefixCountries.forEach((el) => {
            if (event.code === el.code || value === el.code) {
                this.registerForm.controls['prefix'].setValue(el.dial_code);
                this.registerForm.controls['prefix'].updateValueAndValidity();
                this.registerForm.controls['countryCode'].setValue(el.code);
                this.registerForm.controls['country'].setValue(el.name);
                localStorage.setItem('country', el.code);
                this.selectedCode = el.code.toLowerCase();
                this.selectedPrefix = el.dial_code;
                this.selected = el;
            }
        });
    }

    validatePmsForOnly3Step() {
        if (this.step_1_validated === true &&
            this.step_2_validated === true &&
            (this.expiryDate.valid &&
                this.securityCode.valid &&
                this.nameOnCard.valid &&
                this.cardNumber.valid &&
                !this.invalidExpiryDate()) ||
            (this.NettelerSecureId.valid &&
                this.NettelerAccount.valid) ||
            (this.Payee.valid &&
                this.IBAN.valid &&
                this.Swift.valid) ||
            (this.EnterCashEmail.valid) ||
            (this.MoneyBookersId.valid) ||
            (this.currentPM === 'apmgw_Sofort' ||
                this.currentPM === 'apmgw_Trustly_DI' ||
                this.currentPM === 'apmgw_Pugglepay' ||
                // this.currentPM === 'apmgw_MoneyBookers' ||
                this.currentPM === 'apmgw_Interac' ||
                this.currentPM === 'apmgw_Interac_eTransfer' ||
                this.currentPM === 'apmgw_ecoPayz' ||
                this.currentPM === 'apmgw_Giropay')
        ) {
            this.step_3_validated = true;
        } else {
            this.step_3_validated = false;
        }
    }

    clearFields() {
        setTimeout(() => {
            this.registerForm.controls['cardNumber'].reset();
            this.registerForm.controls['nameOnCard'].reset();
            this.registerForm.controls['expiryDate'].reset();
            this.registerForm.controls['securityCode'].reset();
            this.registerForm.controls['NettelerSecureId'].reset();
            this.registerForm.controls['NettelerAccount'].reset();
            this.registerForm.controls['EnterCashEmail'].reset();
            this.validatePmsForOnly3Step();
        }, 600);
    }

    changeBirthDate(value, what) {
        if (what === 'day') {
            this.registerForm.controls['birthDay'].setValue(value);
        }
        if (what === 'month') {
            this.registerForm.controls['birthMonth'].setValue(value);
        }
        if (what === 'year') {
            this.registerForm.controls['birthYear'].setValue(value);
        }
        this.checkIfWillChangeYear();
        this.validateBirthDate();
    }

    changeCurrency(value) {
        if (value) {
            this.registerForm.controls['currency'].setValue(value);
            this.allCurrencies.forEach((currency) => {
                if (currency.Code === value) {
                    this.tmpCurrency = currency;
                }
            });
            this.preselectedCurrency = this.allCurrencies.filter(e => {
                return e.Code === value;
            })[0];
        }
    }

    dwSelectIsOpen(isOpen, context) {
        this.ifDwSelectIsOpen[context] = isOpen;
    }

    validBirthInput(value, what) {
        if (what === 'day') {
            if (value && value >= 1 && value <= 31 && Number.isInteger(+value)) {
                this.androidDayValue = +value;
                this.androidOldDayValue = this.androidDayValue;
            } else if (value && Number.isInteger(+value)) {
                this.androidDayValue = null;
                setTimeout(() => {
                    this.androidDayValue = this.androidOldDayValue;
                }, 1);
            } else {
                this.androidDayValue = 0;
                setTimeout(() => {
                    this.androidDayValue = null;
                }, 1);
            }
        } else if (what === 'month') {
            if (value && value >= 1 && value <= 12 && Number.isInteger(+value)) {
                this.androidMonthValue = +value;
                this.androidOldMonthValue = this.androidMonthValue;
            } else if (value && Number.isInteger(+value)) {
                this.androidMonthValue = null;
                setTimeout(() => {
                    this.androidMonthValue = this.androidOldMonthValue;
                }, 1);
            } else {
                this.androidMonthValue = 0;
                setTimeout(() => {
                    this.androidMonthValue = null;
                }, 1);
            }
        } else if (what === 'year') {
            if (value && value >= 1 && value <= this.lastYear && Number.isInteger(+value)) {
                this.androidYearValue = +value;
                this.androidOldYearValue = this.androidYearValue;
            } else if (value && Number.isInteger(+value)) {
                this.androidYearValue = null;
                setTimeout(() => {
                    this.androidYearValue = this.androidOldYearValue;
                }, 1);
            } else {
                this.androidYearValue = 0;
                setTimeout(() => {
                    this.androidYearValue = null;
                }, 1);
            }
        }
    }

    validateBirthDate() {
        const current = new Date();
        const currentYear = current.getFullYear();
        const lastYear = currentYear - 18;
        const currentMonth = current.getMonth() + 1;
        const currentDay = current.getDate();
        if (this.birthDay.value !== '' && this.birthMonth.value !== '' && this.birthYear.value !== '') {
            if (+this.birthYear.value > +lastYear || (+this.birthYear.value === +lastYear && +this.birthMonth.value > +currentMonth)
                || (+this.birthYear.value >= +lastYear && +this.birthMonth.value >= +currentMonth && +this.birthDay.value > +currentDay)) {
                this.birthDateIsValid = false;
            } else {
                this.birthDateIsValid = true;
            }
        } else {
            this.birthDateIsValid = true;
        }
    }

    checkIfEmailIsAvalible(event) {
        this.emailIsAvalible = true;
        this.email.markAsTouched();
        if (this.email.value && this.email.value.length > 0 && this.email.valid && (this.email.dirty || this.email.touched)) {
            if (this.emailIAarr[this.email.value] === undefined) {
                this.holdButtonDisabled = true;
                this.lotteryService.getLotteries(globals.appDomain + '/user/isAccountExist/exist.json?email=' + this.email.value)
                    .subscribe(
                        response => {
                            this.holdButtonDisabled = false;
                            if (response.message.status === false) {
                                this.emailIsAvalible = true;
                            } else {
                                this.emailIsAvalible = false;
                                this.varInvalid['Email'] = !this.emailIsAvalible;
                            }
                            this.emailIAarr[this.email.value] = this.emailIsAvalible;
                        }
                    );
            } else {
                this.emailIsAvalible = this.emailIAarr[this.email.value];
            }
        }
    }

    auto_checkIfEmailIsAvalible() {
        const timeout = 1000;
        this.lastType = Date.now();
        if (this.email.value && this.email.value.length === 0) {
            this.checkIfEmailIsAvalible(true);
        }
        setTimeout(() => {
            if ((Date.now() - this.lastType) >= timeout) {
                this.checkIfEmailIsAvalible(true);
            }
        }, timeout);
    }

    setErrorMessage(value) {
        this.translate.get(value).subscribe(t => {
            this.tooltipMessage = t;
        });
    }

    invalidEmail(v) {
        const a = this.email.invalid && this.step_1_checked;
        const b = this.email.touched && this.email.value && this.email.value.length > 0;
        const c = (this.email.dirty || this.email.touched) && this.email.invalid;
        const validOrNot = a || this.emailIsAvalible === false && b || c;

        if (v && v.target.id === 'registration_email' && !this.emailIsAvalible && b) {
            this.setErrorMessage('errors.073');
        } else if (this.email && this.email.value && this.email.value.length > 80) {
            this.setErrorMessage('ferrors.22');
        } else if (v && v.target.id === 'registration_email') {
            this.setErrorMessage('ferrors.01');
        }

        return validOrNot;
    }

    invalidPrefix(v) {
        const validOrNot = (this.prefix.invalid &&
            ((this.prefix.value && this.prefix.value.length > 0) || this.step_1_checked)) ||
            (this.prefix.value && this.prefix.value.length === 0 && this.mobile.value.length > 0);
        if (validOrNot && v && (v.target.id === 'registration_prefix' || v.target.id === 'registration_prefix_mat_select')) {
            this.setErrorMessage('ferrors.17');
        }
        return validOrNot;
    }

    phoneValid(event: any) {
        const regExp = /\D/gi;
        if (regExp.test(this.mobile.value) && this.mobile.value) {
            this.registerForm.controls['mobile'].setValue(this.mobile.value.replace(/\D/gi, ''));
        }
    }

    invalidMobile(v) {
        const validOrNot = this.mobile.invalid &&
            (this.mobile.dirty || this.mobile.touched) &&
            this.mobile.value && this.mobile.value.toString().length > 0 ||
            (this.mobile.invalid && this.step_1_checked);
        if (validOrNot && v && v.target.id === 'register_phone') {
            this.setErrorMessage('ferrors.14');
        }
        return validOrNot;
    }

    invalidPassword(v) {
        const validOrNot = this.password.invalid &&
            (this.password.dirty || this.password.touched) &&
            this.password.value && this.password.value.length > 0 ||
            (this.password.invalid && this.step_1_checked);
        return validOrNot;
    }

    invalidFirstName(v) {
        const validOrNot = this.firstName.invalid &&
            (this.firstName.dirty || this.firstName.touched) &&
            this.firstName.value && this.firstName.value.length > 0 ||
            (this.firstName.invalid && this.step_2_checked);
        if (validOrNot && v && v.target.id === 'registration_name') {
            this.setErrorMessage('ferrors.03');
        }
        return validOrNot;
    }

    invalidLastName(v) {
        const validOrNot = this.lastName.invalid &&
            (this.lastName.dirty || this.lastName.touched) &&
            this.lastName.value && this.lastName.value.length > 0 ||
            (this.lastName.invalid && this.step_2_checked);
        if (validOrNot && v && v.target.id === 'registration_surname') {
            this.setErrorMessage('ferrors.05');
        }
        return validOrNot;
    }

    invalidGender(v) {
        const validOrNot = this.gender.invalid &&
            (this.gender.dirty || this.gender.touched) &&
            this.gender.value && this.gender.value.length > 0 ||
            (this.gender.invalid && this.step_2_checked);
        if (validOrNot && v && (v.target.id === 'registration_gender_male' || v.target.id === 'registration_gender_female')) {
            this.setErrorMessage('ferrors.19');
        }
        return validOrNot;
    }

    invalidCity(v) {
        const validOrNot = this.city.invalid &&
            (this.city.dirty || this.city.touched) &&
            this.city.value && this.city.value.length > 0 ||
            (this.city.invalid && this.step_2_checked);
        if (validOrNot && v && v.target.id === 'registration_city') {
            this.setErrorMessage('ferrors.11');
        }
        return validOrNot;
    }

    invalidPostcode(v) {
        const validOrNot = this.postcode.invalid &&
            (this.postcode.dirty || this.postcode.touched) &&
            this.postcode.value && this.postcode.value.length > 0 ||
            (this.postcode.invalid && this.step_2_checked);
        if (validOrNot && v && v.target.id === 'registration_postcode' && (!this.postcode.value || this.postcode.value.length === 0)) {
            this.setErrorMessage('ferrors.18');
        } else if (validOrNot && v && v.target.id === 'registration_postcode' && this.postcode.value && this.postcode.value.length > 0) {
            this.setErrorMessage('ferrors.21');
        }
        return validOrNot;
    }

    invalidAddress(v) {
        const validOrNot = this.address.invalid &&
            (this.address.dirty || this.address.touched) &&
            this.address.value && this.address.value.length > 0 ||
            (this.address.invalid && this.step_2_checked);
        if (validOrNot && v && v.target.id === 'registration_address') {
            this.setErrorMessage('ferrors.20');
        }
        return validOrNot;
    }

    invalidTerms() {
        return !this.terms.value &&
            (this.terms.dirty || this.terms.touched) ||
            (!this.terms.value && this.step_2_checked);
    }

    invalidExpiryDate() {
        let itsInvalid = this.expiryDate.invalid &&
            (this.expiryDate.dirty || this.expiryDate.touched) &&
            this.expiryDate.value && this.expiryDate.value.length > 0 ||
            (this.expiryDate.invalid && this.step_3_checked && this.currentPMchecked === 'Card');

        if (!itsInvalid && (this.expiryDate.dirty || this.expiryDate.touched) && this.expiryDate.value) {
            const monthYear = this.expiryDate.value.split('/');
            const month = monthYear[0] * 1;
            const year = (monthYear[1] * 1) + 2000;
            const currentYear = (new Date()).getFullYear();
            const currentMonth = (new Date()).getMonth() + 1;
            if ((month < currentMonth && year === currentYear) || month < 1 || month > 12
                || year < currentYear || year > (currentYear + 15)) {
                itsInvalid = true;
            }
        }

        return itsInvalid;

    }

    invalidSecurityCode() {
        return this.securityCode.invalid &&
            (this.securityCode.dirty || this.securityCode.touched) &&
            this.securityCode.value && this.securityCode.value.toString().length > 0 ||
            (this.securityCode.invalid && this.step_3_checked && this.currentPMchecked === 'Card');
    }

    invalidNameOnCard() {
        return this.nameOnCard.invalid &&
            (this.nameOnCard.dirty || this.nameOnCard.touched) &&
            this.nameOnCard.value && this.nameOnCard.value.length > 0 ||
            (this.nameOnCard.invalid && this.step_3_checked && this.currentPMchecked === 'Card');
    }

    invalidCardNumber() {
        return this.cardNumber.invalid &&
            (this.cardNumber.dirty || this.cardNumber.touched) &&
            this.cardNumber.value && this.cardNumber.value.length > 0 ||
            (this.cardNumber.invalid && this.step_3_checked && this.currentPMchecked === 'Card');
    }

    invalidNettelerSecureId() {
        return this.NettelerSecureId.invalid &&
            (this.NettelerSecureId.dirty || this.NettelerSecureId.touched) &&
            this.NettelerSecureId.value && this.NettelerSecureId.value.length > 0 ||
            (this.NettelerSecureId.invalid && this.step_3_checked && this.currentPMchecked === 'apmgw_Neteller');
    }

    invalidNettelerAccount() {
        return this.NettelerAccount.invalid &&
            (this.NettelerAccount.dirty || this.NettelerAccount.touched) &&
            this.NettelerAccount.value && this.NettelerAccount.value.length > 0 ||
            (this.NettelerAccount.invalid && this.step_3_checked && this.currentPMchecked === 'apmgw_Neteller');
    }

    invalidPayee() {
        return this.Payee.invalid &&
            (this.Payee.dirty || this.Payee.touched) &&
            this.Payee.value && this.Payee.value.length > 0 ||
            (this.Payee.invalid && this.step_3_checked && this.currentPMchecked === 'apmgw_Fast_Bank_Transfer');
    }

    invalidIBAN() {
        return this.IBAN.invalid &&
            (this.IBAN.dirty || this.IBAN.touched) &&
            this.IBAN.value && this.IBAN.value.length > 0 ||
            (this.IBAN.invalid && this.step_3_checked && this.currentPMchecked === 'apmgw_Fast_Bank_Transfer');
    }

    invalidSwift() {
        return this.Swift.invalid &&
            (this.Swift.dirty || this.Swift.touched) &&
            this.Swift.value && this.Swift.value.length > 0 ||
            (this.Swift.invalid && this.step_3_checked && this.currentPMchecked === 'apmgw_Fast_Bank_Transfer');
    }

    invalidEnterCashEmail() {
        return this.EnterCashEmail.invalid &&
            (this.EnterCashEmail.dirty || this.EnterCashEmail.touched) &&
            this.EnterCashEmail.value && this.EnterCashEmail.value.length > 0 ||
            (this.EnterCashEmail.invalid && this.step_3_checked && this.currentPMchecked === 'apmgw_EnterCash');
    }

    invalidMoneyBookersId() {
        return this.MoneyBookersId.invalid &&
            (this.MoneyBookersId.dirty || this.MoneyBookersId.touched) &&
            this.MoneyBookersId.value && this.MoneyBookersId.value.length > 0 ||
            (this.MoneyBookersId.invalid && this.step_3_checked && this.currentPMchecked === 'apmgw_MoneyBookers');
    }

    invalidBirthYear(v) {
        const validOrNot = !this.birthYear.value && this.step_2_checked || !this.birthDateIsValid;
        if (validOrNot && v && (v.target.id === 'registration_birthyear' ||
            v.target.id === 'registration_birthyear_2' ||
            v.target.id === 'registration_birthyear_3')) {
            this.setErrorMessage('ferrors.07');
        }
        return validOrNot;
    }

    invalidBirthMonth(v) {
        const validOrNot = !this.birthMonth.value && this.step_2_checked || !this.birthDateIsValid;
        if (validOrNot && v && (v.target.id === 'registration_birthmonth' || v.target.id === 'registration_birthmonth_2')) {
            this.setErrorMessage('ferrors.07');
        }
        return validOrNot;
    }

    invalidBirthDay(v) {
        const validOrNot = !this.birthDay.value && this.step_2_checked || !this.birthDateIsValid;
        if (validOrNot && v && (v.target.id === 'registration_birthday' || v.target.id === 'registration_birthday_2')) {
            this.setErrorMessage('ferrors.07');
        }
        return validOrNot;
    }

    showTooltip(event, message, invalid) {
        this.tooltipLoop++;
        setTimeout(() => {
            if (this.activeTooltip) {
                if (invalid === true) {
                    this.showTooltipNOW(event, message);
                } else {
                    const a = {top: '0', left: '0', show: false, message: message};
                    this.subscriptionsService.emitJinniTooltip(a);
                }
            } else if (this.tooltipLoop < 10) {
                this.showTooltip(event, message, invalid);
            }
        }, 50);
    }

    hideTooltip(event) {
        if ((event &&
            event.target &&
            event.target.classList &&
            event.target.classList.contains('canDisableTooltip')) ||
            event === 'canDisableTooltip') {
            this.activeTooltip = false;
            this.tooltipLoop = 0;
            const a = {top: '0', left: '0', show: false, message: ''};
            this.subscriptionsService.emitJinniTooltip(a);
        }
    }

    showTooltipNOW(event, message) {
        const viewportOffset = event.srcElement.getBoundingClientRect();
        const top = viewportOffset.top + (viewportOffset.height / 2);
        let left;
        if (window.innerWidth > 950) {
            left = viewportOffset.left + viewportOffset.width + 9;
        } else {
            left = viewportOffset.left - 170;
        }
        const a = {top: top, left: left, show: true, message: message};
        this.subscriptionsService.emitJinniTooltip(a);
    }

    getAvaliblePaymentMethods() {
        if (this.userService.userData) {
            this.userDetails = this.userService.userData;
        }
        if (this.userDetails && this.userDetails.CountryCode) {
            this.countryForPayments = this.userDetails.CountryCode;
        } else {
            this.countryForPayments = localStorage.getItem('country');
        }
        this.currentMethod = 'Card';
        const langFromLocal = localStorage.getItem('pageLanguage') || 'en';
        this.lotteryService
            .postData(globals.appDomain + '/payments/getAvailablePaymentOptions/getAvailablePaymentOptions_freshReg.json',
                'countryCode=' + this.countryForPayments + '&lang=' + langFromLocal + '&currency=' +
                this.preselectedCurrency.Code + '&SessionID=' + this.userDetails.sessionId)
            .subscribe(
                result => {
                    this.getAvailablePaymentOptions = result.message;
                    if (this.getAvailablePaymentOptions.filter(payMeth => {
                        return payMeth.paymentMethod === 'paystack';
                    }).length > 0) {
                        this.paystackFlow = true;
                        localStorage.setItem('paystackFlow', '' + this.paystackFlow);
                        this.subscriptionsService.emitRegister(false);
                        this.subscriptionsService.emitUserNeedIncreseBalance(-1);
                        this.subscriptionsService.emitForceStepTwo(true);
                    }

                    for (const i in result.message) {
                        if (isArray(result.message[i].requiredFields)) {
                            result.message[i].requiredFieldsArr = result.message[i].requiredFields;
                        } else {
                            result.message[i].requiredFieldsArr = [];
                            for (const index in result.message[i].requiredFields) {
                                if (index !== undefined && result.message[i].requiredFields[index] !== undefined) {
                                    result.message[i].requiredFieldsArr.push(result.message[i].requiredFields[index]);
                                }
                            }
                        }
                    }

                    this.gapo = result.message;
                }
            );
        this.close = true;
    }

    higherThan(higher, than) {
        return higher > than;
    }

    movePMs(k) {
        const step = 110;
        const timMult = 10;
        let simpleStep = 1;
        if (k === 'left') {
            simpleStep = -1;
        }
        for (let n = 0; n <= step; n++) {
            this.movePMsAction(this.paymentMethods.nativeElement.scrollLeft + simpleStep * n, n / timMult);
        }
    }

    dragAndDrop() {
        if (!this.onlyOnce) {
            this.onlyOnce = true;
            let startPos = 0;
            let final = 0;
            this.paymentMethods.nativeElement.scrollLeft = 0;
            let currentPosition = this.paymentMethods.nativeElement.scrollLeft;
            this.globalListenFunc = this.renderer.listen('document', 'mousemove', e => {
                if (!this.isMobile && this.hold) {
                    if (startPos === 0) {
                        startPos = e.screenX;
                    }
                    final = e.screenX - startPos;
                    this.paymentMethods.nativeElement.scrollLeft = currentPosition - final;
                } else if (!this.hold) {
                    startPos = 0;
                    final = 0;
                    currentPosition = this.paymentMethods.nativeElement.scrollLeft;
                }
            });
        }
    }

    movePMsAction(step, timeout) {
        setTimeout(() => {
            this.paymentMethods.nativeElement.scrollLeft = step;
        }, timeout);
    }

    checkType() {
        const checkCartNumber = this.cardNumber.value;
        if (checkCartNumber && checkCartNumber.length > 3) {
            this.cardType = this.cardService.checkNumber(checkCartNumber);
        }
        if (!checkCartNumber.length) {
            this.cardType = undefined;
        }
    }

    addSpacesForCredit() {
        let tmpCCN = '';
        let counter = 0;
        const cardNumber = this.cardNumber.value.replace(/\s/g, '');
        if (cardNumber.length > 3) {
            cardNumber.split('').forEach(function (digit) {
                tmpCCN += digit;
                counter++;
                if (counter % 4 === 0) {
                    tmpCCN += ' ';
                }
            });
            tmpCCN = tmpCCN.trim();
            this.registerForm.controls['cardNumber'].setValue(tmpCCN);
        }
    }

    goToStepForDev(step) {
        if (globals.devMode) {
            console.error('This step switcher working, because developer mode is enabled!');
            if (step === 2) {
                this.getAllCurrencies();
            }
            if (step === 3) {
                this.getAvaliblePaymentMethods();
            }
            this.step = step;
        }
    }

    changeDate(date) {
        if (date !== '') {
            const d = date.split('-');
            this.registerForm.controls['birthDay'].setValue(d[2] * 1);
            this.registerForm.controls['birthMonth'].setValue(d[1] * 1);
            this.registerForm.controls['birthYear'].setValue(d[0] * 1);
        } else {
            this.registerForm.controls['birthDay'].setValue('');
            this.registerForm.controls['birthMonth'].setValue('');
            this.registerForm.controls['birthYear'].setValue('');
        }
        this.validateBirthDate();
    }

    holdYourHorses(e) {
        if ((new Date().getTime() - this.holdHorsesTimestamp) <= 1000) {
            e.preventDefault();
        }
        this.holdHorsesTimestamp = new Date().getTime();
    }

    showLogin() {
        this.closeRegistration();
        this.renderer.addClass(document.body, 'modal-open-login');
        setTimeout(() => {
            this.subscriptionsService.emitLogin(true);
        }, 1500);
    }

    refreshGoTo() {
        if (this.confStat === 'error') {
            this.goTo = 'startFlow';
            this.buttonType = 'submit';
        }
    }

    getAllCurrencies() {
        if (this.userService.userData) {
            this.userDetails = this.userService.userData;
        }
        if (this.userDetails && this.userDetails.CountryCode) {
            this.countryForPayments = this.userDetails.CountryCode;
        } else {
            this.countryForPayments = localStorage.getItem('country');
        }

        this.lotteryService.postData(globals.appDomain +
            '/payments/getAvailableCurrencies/paymentsGetAvailableCurrencies.json',
            'countryCode=' + this.countryForPayments)
            .subscribe(
                response => {
                    if (response && response.status === 200 && response.message) {
                        this.allCurrencies = response.message;

                        if (this.brand === 'winaija') {
                            const tmp = this.allCurrencies.filter(currency => currency.Code === 'NGN');
                            if (tmp.length > 0) {
                                this.allCurrencies = tmp;
                            }
                        }

                        /* for dw-select: */
                        this.allCurrencies.map(function (currency) {
                            currency.selectDisplayName = currency.Name;
                            currency.selectValue = currency.Code;
                        });
                        for (const currency of this.allCurrencies) {
                            if (currency.IsDefault) {
                                this.defaultCurrency = {selectDisplayName: currency.Name, selectValue: currency.Code};
                                this.preselectedCurrency = {
                                    ID: currency.ID, Name: currency.Name, Symbol: currency.Symbol,
                                    Code: currency.Code, Rate: currency.Rate
                                };
                            }
                        }
                        if (!this.defaultCurrency && this.brand === 'qiwi') {
                            this.defaultCurrency = {selectDisplayName: 'Euro', selectValue: 'EUR'};
                        } else if (!this.defaultCurrency && this.brand === 'winaija') {
                            this.defaultCurrency = {selectDisplayName: 'Nigerian naira', selectValue: 'NGN'};
                        }
                        this.registerForm.controls['currency'].setValue(this.defaultCurrency);
                    }
                }
            );
    }

    checkIfWillChangeYear() {
        const current = new Date();
        const currentMonth = current.getMonth() + 1;
        const currentDay = current.getDate();
        if ((+this.birthYear.value === (+this.currentYear - 18)) &&
            ((+this.birthMonth.value > currentMonth) ||
                (+this.birthMonth.value === currentMonth && +this.birthDay.value > currentDay))) {
            const changeYear = '' + (this.currentYear - 19);
            this.defaultYear = {selectDisplayName: changeYear, selectValue: changeYear};
            this.registerForm.controls['birthYear'].setValue(changeYear);

        }
    }

    removeAllSpaces() {
        if (this.emailValueFromInput && this.emailValueFromInput.length >= 2) {
            this.emailValueFromInput = this.emailValueFromInput.replace(new RegExp(' ', 'g'), '');
        }
    }

    getBonusDetails() {
        this.bonusService.getBonusDetails().then((resp: any) => {
            if (resp.message.Incentive && resp.message.Incentive.Type) {
                this.bonusDetails = resp.message.Incentive;
            }
        });
    }

    resetBonusDetails() {
        this.bonusDetails = undefined;
    }

    removeBonusDetails(userIncentiveId) {
        this.bonusService.cancelBonus(userIncentiveId).then(() => {
            this.showConfirmation = !this.showConfirmation;
            this.resetBonusDetails();
            this.getBonusDetails();
        });
    }

    askForRmoveBonusDetails(userIncentiveId) {
        this.showConfirmation = !this.showConfirmation;
    }
}
